import { PromoAssetBanner } from '@shipt/design-system-banner'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { DynamicSpecialRequestModal } from '@/features/shop/components/Modal/SpecialRequestModal/DynamicSpecialRequestModal'

export const SpecialRequestGridCard = () => {
  const { openDialog } = useHandleDialog()

  const handleOnClick = () => openDialog(DynamicSpecialRequestModal)

  return (
    <PromoAssetBanner
      onClick={handleOnClick}
      size="sm"
      type="leading"
      asset={<Image src={objectStorageUrl('call-bell.png')} alt="" width={32} height={26} />}
      title="Can't find what you need?"
      description="Ask your shopper to look for it in store by adding a Special Request."
      hasEmphasis
      actionButton={{
        content: 'Add a Special Request',
        onClick: handleOnClick,
        variant: 'primary',
        'aria-label': 'Add a Special Request',
      }}
    />
  )
}
